export enum ErrorType {
  // Common Errors
  NETWORK = 'Network',
  USER_CANCELED = 'UserCanceled',
  UNKNOWN = 'Unknown',

  // Server
  JSON_PARSE_ERROR = 'JsonParseError',
  BAD_REQUEST = 'BadRequest',
  INTERNAL_SERVER_ERROR = 'InternalServerError',
  UNAUTHORIZED = 'Unauthorized',
  UNAUTHENTICATED = 'Unauthenticated',
  FORBIDDEN = 'Forbidden',
  CONTRACT_VERSION_TOO_LOW = 'ContractVersionTooLow',

  PRODUCT_NOT_PURCHASABLE = 'ProductNotPurchasable',
  MONETIZATION_SYNC = 'MonetizationSync',
  PRODUCT_NOT_FOUND = 'ProductNotFound',
  PRODUCT_OWNER_NOT_FOUND = 'ProductOwnerNotFound',
  PURCHASE_SYNC_EXCEPTION = 'PurchaseSyncException',
  UNEXPECTED_AMOUNT = 'UnexpectedAmount',
  PRODUCT_OWNER_REQUIRED = 'ProductOwnerRequired',
  DISCOUNT_NOT_APPLICABLE = 'DiscountNotApplicable',
  CODE_ALREADY_REDEEMED = 'CodeAlreadyRedeemed',
  CODE_NOT_FOUND = 'CodeNotFound',
  COUPON_EXPIRED = 'CouponExpired',
  COUPON_NOT_YET_REDEEMABLE = 'CouponNotYetRedeemable',
  PRODUCT_ALREADY_IN_POSSESSION = 'ProductAlreadyInPossession',
  PRODUCT_NOT_AVAILABLE = 'ProductNotAvailable',

  // Client
  BRAINTREE = 'Braintree',
  UNEXPECTED_CODE_TYPE = 'UnexpectedCodeType',
  UNEXPECTED_DISCOUNT_CODE = 'UnexpectedDiscountCode',
}

export class PaymentError extends Error {
  public errorCode: ErrorType;
  public devDescription: string;

  constructor(code: ErrorType, description = '') {
    super(description);
    Object.setPrototypeOf(this, PaymentError.prototype);
    this.errorCode = code;
    this.devDescription = description;
  }
}
